import {XHttpClient} from "../../http/client"

export default new XHttpClient('http://httpbin.org', {ratePerMinute: 20})
